import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import LoungePage from "./pages/LoungePage";
import CustomDesignPage from "./pages/CustomDesignPage";
import AuthPage from "./pages/AuthPage";
import { CartProvider } from "./context/CartContext";
import { AdminProvider } from "./context/AdminContext";
import { CustomerProvider } from "./context/CustomerContext";
import { Toaster } from "./components/ui/toaster";

// Customer Account Pages
import AccountProtectedRoute from "./pages/account/AccountProtectedRoute";
import AccountOverview from "./pages/account/AccountOverview";
import AccountOrders from "./pages/account/AccountOrders";
import AccountOrderDetail from "./pages/account/AccountOrderDetail";
import AccountReturns from "./pages/account/AccountReturns";
import AccountWarranty from "./pages/account/AccountWarranty";
import AccountAddresses from "./pages/account/AccountAddresses";
import AccountSettings from "./pages/account/AccountSettings";

// Admin Pages
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminProtectedRoute from "./pages/admin/AdminProtectedRoute";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminInventory from "./pages/admin/AdminInventory";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminReturns from "./pages/admin/AdminReturns";
import AdminDiscounts from "./pages/admin/AdminDiscounts";
import AdminShipping from "./pages/admin/AdminShipping";
import AdminFraud from "./pages/admin/AdminFraud";
import AdminWarranty from "./pages/admin/AdminWarranty";

// Layout wrapper for public pages
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <Navigation />
    {children}
    <Footer />
    <ChatWidget />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminProvider>
          <CustomerProvider>
            <CartProvider>
              <Routes>
                {/* Admin Routes */}
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin" element={<AdminProtectedRoute />}>
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="inventory" element={<AdminInventory />} />
                  <Route path="customers" element={<AdminCustomers />} />
                  <Route path="returns" element={<AdminReturns />} />
                  <Route path="discounts" element={<AdminDiscounts />} />
                  <Route path="shipping" element={<AdminShipping />} />
                  <Route path="fraud" element={<AdminFraud />} />
                  <Route path="warranty" element={<AdminWarranty />} />
                </Route>

                {/* Customer Account Routes */}
                <Route path="/auth" element={<PublicLayout><AuthPage /></PublicLayout>} />
                <Route path="/account" element={<PublicLayout><AccountProtectedRoute /></PublicLayout>}>
                  <Route index element={<AccountOverview />} />
                  <Route path="orders" element={<AccountOrders />} />
                  <Route path="orders/:orderId" element={<AccountOrderDetail />} />
                  <Route path="returns" element={<AccountReturns />} />
                  <Route path="warranty" element={<AccountWarranty />} />
                  <Route path="addresses" element={<AccountAddresses />} />
                  <Route path="settings" element={<AccountSettings />} />
                </Route>

                {/* Public Routes */}
                <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
                <Route path="/lounge" element={<PublicLayout><LoungePage /></PublicLayout>} />
                <Route path="/custom-design" element={<PublicLayout><CustomDesignPage /></PublicLayout>} />
                <Route path="/shop/:category" element={<PublicLayout><ShopPage /></PublicLayout>} />
                <Route path="/product/:slug" element={<PublicLayout><ProductDetailPage /></PublicLayout>} />
                <Route path="/cart" element={<PublicLayout><CartPage /></PublicLayout>} />
                <Route path="/checkout" element={<PublicLayout><CheckoutPage /></PublicLayout>} />
                <Route path="/checkout/success" element={<PublicLayout><CheckoutSuccessPage /></PublicLayout>} />
                <Route path="/order/:orderId/success" element={<PublicLayout><OrderSuccessPage /></PublicLayout>} />
              </Routes>
              <Toaster />
            </CartProvider>
          </CustomerProvider>
        </AdminProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
